import VueElement from './vue'

export default class PageLayout extends VueElement {
  static vueComponent = 'page-layout'

  static permanent = true

  get props () {
    let items = this.getAttribute('nav') ?? '[]'
    let teams = this.getAttribute('teams') ?? '[]'

    if (typeof items === 'string') {
      try {
        items = JSON.parse(items)
      } catch (error) {
        items = []
      }
    }

    if (typeof teams === 'string') {
      try {
        teams = JSON.parse(teams)
      } catch (error) {
        teams = []
      }
    }

    return {
      currentNavItems: items,
      role: this.getAttribute('role') ?? 'viewer',
      name: this.getAttribute('name') ?? null,
      query: this.getAttribute('search') ?? null,
      teams
    }
  }
}
